import { render, staticRenderFns } from "./ProcrastinationPreventionModal.vue?vue&type=template&id=ec487e5e&scoped=true&"
import script from "./ProcrastinationPreventionModal.vue?vue&type=script&lang=js&"
export * from "./ProcrastinationPreventionModal.vue?vue&type=script&lang=js&"
import style0 from "./ProcrastinationPreventionModal.vue?vue&type=style&index=0&id=ec487e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec487e5e",
  null
  
)

export default component.exports